import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { PlanPermissionsComponent } from './plan-permissions.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { PermissionSelectorModule } from 'src/app/shared/components/permission-selector/permission-selector.module';

@NgModule({
  declarations: [
    PlanPermissionsComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    PermissionSelectorModule
  ],
  exports: [
    PlanPermissionsComponent
  ]
})
export class PlanPermissionsModule { }
